/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { OpaqueToken, ReflectiveInjector  } from "@angular/core";
import { InaxSignalR, SignalrWindow } from "../signalR";

export interface IHubService{
    readonly hubName:string;
    registerEvents(signalR: InaxSignalR);
}

export const IHUBSERVICE_TOKEN: OpaqueToken = new OpaqueToken('IHubService');
